import { queryOptions, useQuery } from '@tanstack/react-query';

import { discountsApi } from '../api/discounts-api';

import { discountKeys } from './discount-keys';

export function discountQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: discountKeys.detail(storeId, id),
    queryFn: () => discountsApi.get(storeId, id),
  });
}

export function useDiscount(storeId: string, id: string) {
  return useQuery(discountQueryOptions(storeId, id));
}
